import { useEffect, useState } from "react";
import { useWebSocketContext } from "../providers/WebSocketContextProvider";
import useSmartRef from "./useSmartRef";

export default function useQueueHandler(userQueueName) {

  const {get:getMySubsList}              = useSmartRef({});  
  const {wsSubscribe}                    = useWebSocketContext();
  const [queueData, setQueueData]        = useState(null);


  //------[   Effect  userQueueName   ]-------  SubscribeIfAbsent
  //
  useEffect(()=>{
    // ---[  Subscribe If Absent  ]---
    //
    const subscribeIfAbsent = (channelName, handler) => {
      if ( !Boolean(getMySubsList()[channelName]) ) {
        const sId = wsSubscribe(channelName, handler, true);
        if (sId) {
          getMySubsList()[channelName] = sId;
          //console.log('[useQueueHandler subscribeIfAbsent] My Page List [channel: %s] [sId: %s]', channelName, sId);
        }
        else {
          console.error('[useQueueHandler subscribeIfAbsent] No Result from wsSubscribe [sId: %s]', sId);
        }

        return sId;
      }
      else {
        return null;
      }
    };

    // ---[  On Queue Data  ]---
    // 
    const onQueueData = (msg) => {
      msg.ack();
      if (msg.body) {
        const data = JSON.parse(msg.body);
        //console.log('[useQueueHandler onQueueData] [data: %s]', JSON.stringify(data, null, 2));
        setQueueData(data);
      }
    }


    //------   DO:  ------

    if (userQueueName) {
      const qPath = `/user/queue/${userQueueName}`;
      subscribeIfAbsent(qPath, onQueueData);
    }

  },[userQueueName, getMySubsList, wsSubscribe]);

  // cleanQueue ??? is it required at all?

  return {
    queueData, setQueueData
  }
}
